module.exports = __webpack_public_path__ + "img/form.37eb737.png";